module.exports = __webpack_public_path__ + "static/media/subcon-account.eae10d78.svg";